<app-device-features-container
  [header]="'+INSTALLATIONS.INSTALLATION.PHOTOVOLTAICS.TITLE' | translate"
  [deviceSelectId]="deviceSelectId"
  [overlayType]="availableOverlays.Photovoltaics"
  actionButtonName="{{
    '+INSTALLATIONS.INSTALLATION.FEATURE_CONTAINER.DETAILS_BUTTON' | translate
  }}"
>
  <!-- photovoltaic.status -->
  <!-- ess.photovoltaic.status -->

  <ng-container feature *ngIf="exceptionsState || basicState; else photovoltaicOperationState">
    <app-feature-tile
      feature
      [label]="'+INSTALLATIONS.INSTALLATION.VITOCHARGE.PHOTOVOLTAICS.STATUS' | translate"
      [value]="basicState"
      [attr.isFullWidth]="isStatusFeatureFullWidth"
      [preLabel]="exceptionsState"
      [preLabelStyles]="preLabelStyles"
    ></app-feature-tile>
  </ng-container>

  <ng-template #photovoltaicOperationState>
    <app-feature-tile
      data-at-photovoltaic-status
      *ngIf="photovoltaicStatus$ | async | ready as feature"
      feature
      [label]="'+INSTALLATIONS.INSTALLATION.VITOCHARGE.PHOTOVOLTAICS.STATUS' | translate"
      [value]="feature | value2: featurePropertyKey.status | translatePhotovoltaicState"
      [attr.data-feature]="feature.feature"
      [attr.isFullWidth]="isStatusFeatureFullWidth"
    ></app-feature-tile>
  </ng-template>

  <!-- photovoltaic.production.current.consolidated for cascade device -->
  <app-feature-tile
    data-at-photovoltaic-power
    *ngIf="
      (devicesStore.shouldUseConsolidatedFeature$ | async) &&
        (productionCurrentConsolidatedFeatures$ | async | ready) &&
        (productionCurrentConsolidatedPerDevice$ | async) as feature;
      else productionCurrent
    "
    feature
    [label]="'+INSTALLATIONS.INSTALLATION.VITOCHARGE.PHOTOVOLTAICS.PRODUCTION' | translate"
    value="{{ feature | featureLike | value2: featurePropertyKey.value }} {{
      feature | featureLike | unit: featurePropertyKey.value
    }}"
  >
  </app-feature-tile>

  <!-- photovoltaic.production.current.consolidated for single device-->
  <ng-template #productionCurrent>
    <app-feature-tile
      data-at-photovoltaic-power
      *ngIf="photovoltaicCurrentProduction$ | async | ready as feature"
      feature
      [error]="feature | error"
      [label]="'+INSTALLATIONS.INSTALLATION.VITOCHARGE.PHOTOVOLTAICS.PRODUCTION' | translate"
      value="{{ feature | value2: featurePropertyKey.value }} {{
        feature | unit: featurePropertyKey.value
      }}"
      [attr.data-feature]="feature.feature"
    >
    </app-feature-tile>
  </ng-template>

  <!-- photovoltaic.production.cumulated -->
  <app-feature-tile
    data-at-photovoltaic-energy
    *ngIf="photovoltaicCumulatedEnergy$ | async | ready as feature"
    feature
    [error]="feature | error"
    [label]="'+INSTALLATIONS.INSTALLATION.VITOCHARGE.PHOTOVOLTAICS.PRODUCTION_COUNTER' | translate"
    value="{{ feature | value2: featurePropertyKey.lifeCycle }} {{
      feature | unit: featurePropertyKey.lifeCycle
    }}"
    [attr.data-feature]="feature.feature"
  >
  </app-feature-tile>

  <!-- photovoltaic.insulationResistance.system -->
  <ng-container feature *ngIf="photovoltaicInsulationResistance$ | async | ready as feature">
    <app-feature-tile
      *ngIf="
        (feature | value2: featurePropertyKey.status) ===
        photovoltaicInsulationResistanceStatus.valid
      "
      data-at-photovoltaic-insulationresistance-system
      feature
      [error]="feature | error"
      value="{{ feature | value2: featurePropertyKey.value }} {{
        feature | unit: featurePropertyKey.value
      }}"
      [label]="
        '+INSTALLATIONS.INSTALLATION.VITOCHARGE.PHOTOVOLTAICS.INSULATION_RESISTANCE' | translate
      "
      [attr.data-feature]="feature.feature"
    >
    </app-feature-tile>
  </ng-container>
</app-device-features-container>
